require('./bootstrap')

import { createApp } from 'vue';
import dayjs from 'dayjs';
import i18n from './lang/index';
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import * as Constants from './constants'

import TableData from './components/TableData';
import ElemenentPlus from 'element-plus';
import IconSubMenu from './components/IconSubMenu';
import FormLogin from './components/auth/FormLogin';
import ResetPassword from './components/auth/ResetPassword'
import NotiSendMail from './components/auth/NotiSendMail'
import FormResetPassoword from './components/auth/FormResetPassword'
import AlertMessage from './components/AlertMessage'
import NoticeCard from './components/NoticeCard'
import CompanyList from './components/companies/CompanyList'
import CompanyForm from './components/companies/CompanyForm'
import StaffList from "./components/staff/StaffList";
import StaffForm from "./components/staff/StaffForm";
import ShopList from "./components/shop/ShopList";
import ShopForm from "./components/shop/ShopForm";
import ShopDetail from './components/shop/ShopDetail'
import DialogResetAccount from './components/DialogResetAccount'
import UserList from "./components/user/UserList";
import CompanyDetail from "./components/companies/CompanyDetail";
import StaffDetail from './components/staff/StaffDetail'
import FormSearchDate from './components/staff/FormSearchDate'
import NoteLoginId from './components/NoteLoginId'
import DateForm from './components/DateForm'
import TableNotice from './components/notices/TableNotice'
import UserNoticeList from './components/notices/user/UserNoticeList'
import UserDetail from "./components/user/UserDetail";
import UserForm from "./components/user/UserForm";
import UserNoticeForm from './components/notices/user/UserNoticeForm'
import NoticeDetail from './components/notices/NoticeDetail'
import PartnerNoticeList from './components/notices/partner/PartnerNoticeList'
import PartnerNoticeForm from './components/notices/partner/PartnerNoticeForm'
import TransactionList from './components/transactions/TransactionList'
import UserContactList from './components/contacts/user/UserContactList'
import PartnerContactList from './components/contacts/partner/PartnerContactList'
import TransactionDetail from './components/transactions/TransactionDetail'
import DialogConfirmCancel from './components/transactions/DialogConfirmCancel'
import DialogCancelComplete from './components/transactions/DialogCancelComplete'
import OtherContactList from './components/contacts/other/OtherContactList'
import ContactDetail from './components/contacts/ContactDetail'
import DialogDeleteNotice from './components/notices/DialogDeleteNotice'
import ListContactMessage from './components/contacts/ListContactMessage'
import DialogComment from './components/contacts/DialogComment'
import DialogConfirmComment from './components/contacts/DialogConfirmComment'
import DialogSendMessageComplete from './components/contacts/DialogSendMessageComplete'
import DialogResolveContact from './components/contacts/DialogResolveContact'
import DialogUnresolveContact from './components/contacts/DialogUnresolveContact'
import CompanyProfit from './components/profits/company/CompanyProfit'
import ProfitConditionSearch from './components/profits/ProfitConditionSearch'
import ProfitSearchDate from './components/profits/ProfitSearchDate'
import ListProfitData from './components/profits/ListProfitData'
import OverviewProfit from './components/profits/OverviewProfit'
import DialogExportData from './components/profits/DialogExportData'
import DialogSelectArea from './components/profits/DialogSelectArea'
import ShopProfit from './components/profits/shop/ShopProfit'
import DialogSelectGenre from './components/profits/DialogSelectGenre'
import StaffProfit from './components/profits/staff/StaffProfit'
import FormChangePassword from './components/auth/FormChangePassword'
import VueQrcode from "@chenfengyuan/vue-qrcode";
import FormFirstLogin from './components/auth/FormFirstLogin'
import ShowPoint from './components/point/ShowPoint'
import FormForgotLoginId from './components/auth/FormForgotLoginId'
import PartnerContactForm from './components/contacts/PartnerContactForm'
import ListMessageAdmin from './components/contacts/ListMessageAdmin';
import ListMessagePartner from './components/contacts/ListMessagePartner';
import ScrollTop from './components/ScrollTop';
import CheckinShopLoginStaff from './components/auth/CheckinShopLoginStaff';
import ContactMailSend from './components/contacts/mail/MailSend';
import ContactMailVerify from './components/contacts/mail/MailVerify';
import ContactMailDone from './components/contacts/mail/MailDone';
import DialogCheckHasMail from './components/contacts/DialogCheckHasMail';
import HeaderTopMobile from './components/HeaderTopMobile';

const app = createApp({});

app.use(ElemenentPlus);
app.use(i18n);
app.component(VueQrcode.name, VueQrcode);

app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.$appUrl = process.env.MIX_APP_URL;
app.config.globalProperties.$timezone = process.env.MIX_TIME_ZONE;
app.config.globalProperties.$siteType = Constants.SITE_TYPE;
app.config.globalProperties.$userRole = Constants.USER_ROLE;
app.config.globalProperties.$httpStatus = Constants.HTTP_STATUS;
app.config.globalProperties.$maxSizeImage = Constants.MAX_SIZE_IMAGE;
app.config.globalProperties.$noticeType = Constants.NOTICE_TYPE;
app.config.globalProperties.$contactFrom = Constants.CONTACT_FROM;
app.config.globalProperties.$statusContact = Constants.STATUS_CONTACT;
app.config.globalProperties.$regions = Constants.REGIONS;
app.config.globalProperties.$typeProfit = Constants.TYPE_PROFIT;
app.config.globalProperties.$partnerStatus = Constants.PARTNER_STATUS;
app.config.globalProperties.$maxSizeImageByte = Constants.MAX_SIZE_IMAGE_BYTE;
app.config.globalProperties.$lineUrl = Constants.LINE_URL;
app.config.globalProperties.$loginType = Constants.LOGIN_TYPE;

dayjs.extend(require('dayjs/plugin/timezone'));
dayjs.extend(require('dayjs/plugin/utc'));
dayjs.tz.setDefault(process.env.MIX_TIME_ZONE);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.component('table-data', TableData);
app.component('icon-sub-menu', IconSubMenu);
app.component('form-login', FormLogin);
app.component('reset-password', ResetPassword);
app.component('noti-send-mail', NotiSendMail);
app.component('form-reset-password', FormResetPassoword);
app.component('alert-message', AlertMessage);
app.component('notice-card', NoticeCard);
app.component('company-list', CompanyList);
app.component('company-form', CompanyForm);
app.component('company-detail', CompanyDetail);
app.component('shop-list', ShopList);
app.component('shop-form', ShopForm);
app.component('shop-detail', ShopDetail);
app.component('staff-list', StaffList);
app.component('staff-form', StaffForm);
app.component('dialog-reset-account', DialogResetAccount);
app.component('user-list', UserList);
app.component('staff-detail', StaffDetail);
app.component('form-search-date', FormSearchDate);
app.component('user-form', UserForm);
app.component('user-detail', UserDetail);
app.component('note-login-id', NoteLoginId);
app.component('date-form', DateForm);
app.component('table-notice', TableNotice);
app.component('user-notice-list', UserNoticeList);
app.component('user-notice-form', UserNoticeForm);
app.component('partner-notice-list', PartnerNoticeList);
app.component('notice-detail', NoticeDetail);
app.component('partner-notice-form', PartnerNoticeForm);
app.component('transaction-list', TransactionList);
app.component('user-contact-list', UserContactList);
app.component('partner-contact-list', PartnerContactList);
app.component('transaction-detail', TransactionDetail);
app.component('dialog-confirm-cancel', DialogConfirmCancel);
app.component('dialog-cancel-complete', DialogCancelComplete);
app.component('other-contact-list', OtherContactList);
app.component('contact-detail', ContactDetail);
app.component('dialog-delete-notice', DialogDeleteNotice);
app.component('list-contact-message', ListContactMessage);
app.component('dialog-comment', DialogComment);
app.component('dialog-confirm-comment', DialogConfirmComment);
app.component('dialog-send-message-complete', DialogSendMessageComplete);
app.component('dialog-resolve-contact', DialogResolveContact);
app.component('dialog-unresolve-contact', DialogUnresolveContact);
app.component('company-profit', CompanyProfit);
app.component('profit-condition-search', ProfitConditionSearch);
app.component('profit-search-date', ProfitSearchDate);
app.component('list-profit-data', ListProfitData);
app.component('overview-profit', OverviewProfit);
app.component('dialog-export-data', DialogExportData);
app.component('dialog-select-area', DialogSelectArea);
app.component('shop-profit', ShopProfit);
app.component('dialog-select-genre', DialogSelectGenre);
app.component('staff-profit', StaffProfit);
app.component('form-change-password', FormChangePassword);
app.component('form-first-login', FormFirstLogin);
app.component('show-point', ShowPoint);
app.component('form-forgot-login-id', FormForgotLoginId);
app.component('partner-contact-form', PartnerContactForm);
app.component('list-message-admin', ListMessageAdmin);
app.component('list-message-partner', ListMessagePartner);
app.component('scroll-top', ScrollTop);
app.component('checkin-shop-login-staff', CheckinShopLoginStaff);
app.component('contact-mail-send', ContactMailSend);
app.component('contact-mail-verify', ContactMailVerify);
app.component('contact-mail-done', ContactMailDone);
app.component('dialog-check-has-mail', DialogCheckHasMail);
app.component('header-top-mobile', HeaderTopMobile);

app.mount('#app');
